const DEFAULT_SPOTLIGHT_ROLLOUT = {
  enabled: true,
  rolloutStage: "full",
  topDestinationsEnabled: true,
  topExperiencesEnabled: true,
};

const normalizeBoolean = (value, fallback = false) => {
  if (value === undefined || value === null || value === "") return fallback;
  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    if (["true", "1", "yes", "on"].includes(normalized)) return true;
    if (["false", "0", "no", "off"].includes(normalized)) return false;
  }
  return Boolean(value);
};

export const normalizeSpotlightRolloutConfig = (value = {}) => ({
  enabled: normalizeBoolean(value?.enabled, DEFAULT_SPOTLIGHT_ROLLOUT.enabled),
  rolloutStage:
    String(value?.rolloutStage || DEFAULT_SPOTLIGHT_ROLLOUT.rolloutStage).trim() ||
    DEFAULT_SPOTLIGHT_ROLLOUT.rolloutStage,
  topDestinationsEnabled: normalizeBoolean(
    value?.topDestinationsEnabled,
    DEFAULT_SPOTLIGHT_ROLLOUT.topDestinationsEnabled,
  ),
  topExperiencesEnabled: normalizeBoolean(
    value?.topExperiencesEnabled,
    DEFAULT_SPOTLIGHT_ROLLOUT.topExperiencesEnabled,
  ),
});

export const isSpotlightSectionEnabled = (
  rolloutConfig = DEFAULT_SPOTLIGHT_ROLLOUT,
  sectionType = "",
) => {
  const rollout = normalizeSpotlightRolloutConfig(rolloutConfig);
  if (!rollout.enabled) return false;

  switch (String(sectionType || "").trim()) {
    case "top-destination":
      return rollout.topDestinationsEnabled;
    case "top-experience":
      return rollout.topExperiencesEnabled;
    default:
      return true;
  }
};

export { DEFAULT_SPOTLIGHT_ROLLOUT };
